export const MY_LOAN_DATA = 'MY_LOAN_DATA'
export const AMOUNT_FRONT_APPLY_STATE = 'AMOUNT_FRONT_APPLY_STATE'
export const GET_MY_LOAN_DATA = 'GET_MY_LOAN_DATA'
export const SET_MY_LOAN_DATA = 'SET_MY_LOAN_DATA'

/* 单个贷款状态 */
export const FRONT_ITEM_STATE_FRONT = 'FRONT_ITEM_STATE_FRONT'
export const SET_FRONT_ITEM_STATE_FRONT = 'SET_FRONT_ITEM_STATE_FRONT'
// export const GET_FRONT_ITEM_STATE_FRONT = 'GET_FRONT_ITEM_STATE_FRONT'



// WEBPACK FOOTER //
// ./src/vuex/types/personaCenter/myLoan.js